<template>
  <div class="row">
    <div style="width: 100%; margin-left: 1rem; margin-right: 1rem">
      <a-tabs :default-active-key="defaultTabActive" @change="handleChangeTab">
        <a-tab-pane :key="1" :tab="$t('sideBar.editProfile')" />
        <a-tab-pane :key="2" :tab="$t('account.bankAccount')" />
      </a-tabs>
    </div>
    <edit-profile v-if="defaultTabActive === 1" />
    <bank-account v-if="defaultTabActive === 2" />
  </div>
</template>

<script>
import EditProfile from './Profile'
import BankAccount from './BankAccount'

export default {
  components: {
    EditProfile,
    BankAccount,
  },
  data: function () {
    return {
      defaultTabActive: 1,
    }
  },
  methods: {
    handleChangeTab (value) {
      this.defaultTabActive = value
    },
  },
}
</script>
